export default "__VITE_ASSET__95c96b7a__"